import { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";

export default function CustomValueMultiSelect({ defaultOptions, onChange, disabled, prefixValue }) {
    const [value, setValue] = useState(defaultOptions);

    useEffect(() => {
        setValue(defaultOptions);
    }, [defaultOptions]);

    const handleCreate = (inputValue) => {
        if (!prefixValue) {
            const newOption = {
                label: inputValue,
                value: inputValue,
            };

            setValue((prev) => [...prev, newOption]);
            return;
        }
        const formatted = `${prefixValue}:${inputValue}`;

        const newOption = {
            label: formatted,
            value: formatted,
        };

        setValue((prev) => [...prev, newOption]);
    };

    return (
        <CreatableSelect
            isMulti
            value={value}
            onChange={(val) => {
                setValue(val);
                onChange?.(val);
            }}
            onCreateOption={handleCreate}
            className={disabled ? "opacity-50" : ""}
            placeholder="Type gamecode and press Enter"
            noOptionsMessage={() => "Type gamecode and press Enter"}
            classNamePrefix="select"
            isDisabled={disabled}
        />
    );
}